export const fontFamily = (language) => {
	return {
		alvar: {
			light: 'FSAlvarLight',
			regular: 'FSAlvarRegular',
			bold: 'FSAlvarBold',
		},
		albert:
			language === 'ar'
				? {
						light: 'FSAlbertArabicLight',
						regular: 'FSAlbertArabicRegular',
						bold: 'FSAlbertArabicBold',
				  }
				: {
						light: 'FSAlbertLight',
						regular: 'FSAlbertRegular',
						bold: 'FSAlbertBold',
				  },
	};
};

export const fontSize = (language, fontSize) => {
	return `${language === 'ar' ? fontSize + 2 : fontSize}px`;
};
